import { render, staticRenderFns } from "./memberRelease.vue?vue&type=template&id=257533b3&scoped=true"
import script from "./memberRelease.vue?vue&type=script&lang=js"
export * from "./memberRelease.vue?vue&type=script&lang=js"
import style0 from "./memberRelease.vue?vue&type=style&index=0&id=257533b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257533b3",
  null
  
)

export default component.exports